<template>
  <div>
    <div @click="back" class="header">
      <i class="iconfont">&#xe604;</i>
    </div>
    <div class="content">
      <div>
        <span>新密码</span>
        <input type="password" placeholder="填写新密码" v-model="newpass">
      </div>
      <div>
        <span>确认密码</span>
        <input type="password" placeholder="再次填写确认" v-model="confirmpass">
      </div>
    </div>
    <div class="footer">
      <button type="submit" @click="handleReviseClick">{{state}}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RevisepaywordMess',
  data () {
    return {
      state: '完成',
      newpass: '',
      confirmpass: ''
    }
  },
  methods: {
    back () {
      this.$router.go(-1) // 返回上一层
    },
    // 验证
    handleReviseClick () {
      this.state = '提交中...'
      this.bus.$emit('loading', true)
      if (this.newpass !== '') {
        if (this.confirmpass !== '') {
          this.axios.post('/ApiMe/PostChangePayPassword', {
            NewPassword: this.newpass,
            ConfirmPassword: this.confirmpass,
            code: decodeURIComponent(this.$route.query.code)
          }).then(this.postReviInfoSucc)
            .catch(this.postReviInfoFail)
        } else {
          alert('请确认密码')
        }
      } else {
        alert('请输入密码')
      }
    },
    // 提交
    postReviInfoSucc (res) {
      this.state = '再次提交'
      res = res.data
      if (res.ret && res.okInfo === 'succeed') {
        alert('提交成功')
        this.$router.push({
          path: '/me'
        })
      }
    },
    postReviInfoFail (err) {
      alert(err)
    }
  }
}
</script>

<style scoped>
.header{ padding: 10px 15px; padding-bottom: 30px;}
.header .iconfont{ font-size: 25px;}
.content{ padding-left: 15px;}
.content input{ border: 0; border-bottom: 1px solid #dcdcdc; width: 73%; height: 30px;}
.content div{ padding-bottom: 10px; display: flex; align-items: center;}
input::-webkit-input-placeholder{ color:#b6b6b6; padding: 5px; font-size: 14px; line-height: 5px; font-family: Arial,"Microsoft YaHei";}
.content span{ display: block; width: 20%;}
.content p{ color: #b8b8b8; font-size: 12px;}
.footer{ padding: 15px 0;}
.footer button{ width: 80%; margin-right: auto; margin-left: auto; background-color: #ed2727; color: #fff; display: block; border: 0; height: 33px; border-radius: 3px; font-size: 14px; font-family: Arial,"Microsoft YaHei";}
</style>



// WEBPACK FOOTER //
// src/pages/revise_pay_password/components/Mess.vue